import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { HeroCanvas } from './HeroCanvas';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const {
    t
  } = useI18n();
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 bg-[#FAFAFA]" data-id="element-142">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-violet-100/60 via-[#FAFAFA] to-[#FAFAFA]" data-id="element-143" />
      <HeroCanvas data-id="element-144" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center flex flex-col items-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-black/[0.08] bg-white/80 backdrop-blur-sm mb-8 shadow-sm" data-id="element-146">
          <span className="w-2 h-2 rounded-full bg-violet-electric animate-pulse" data-id="element-147" />
          <span className="text-xs font-mono text-[#4A4A55] uppercase tracking-wider" data-id="element-148">
            {t('hero.eyebrow')}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-display text-7xl md:text-9xl lg:text-[12rem] leading-none tracking-tight text-[#0A0A0F] mb-6" data-id="element-149">
          CLVN–LRR™
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-[#2A2A35] max-w-3xl font-light leading-relaxed mb-6" data-id="element-150">
          {t('hero.subtitle')}
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5,
        ease: 'easeOut'
      }} className="text-sm md:text-base text-[#6A6A75] max-w-2xl mb-12" data-id="element-151">
          {t('hero.description')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-wrap items-center justify-center gap-4" data-id="element-152">
          <button onClick={() => scrollTo('marco')} className="px-8 py-3 bg-[#0A0A0F] text-white font-medium rounded-full hover:bg-[#2A2A35] transition-colors" data-id="element-153">
            {t('hero.btnExplore')}
          </button>
          <button onClick={() => scrollTo('papers')} className="px-8 py-3 bg-white border border-black/[0.1] text-[#0A0A0F] font-medium rounded-full hover:bg-[#F4F4F6] transition-colors" data-id="element-154">
            {t('hero.btnPaper')}
          </button>
          <button onClick={() => scrollTo('aplicaciones')} className="px-8 py-3 text-[#4A4A55] hover:text-[#0A0A0F] font-medium transition-colors" data-id="element-155">
            {t('hero.btnApps')}
          </button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-[#8A8A95] animate-bounce cursor-pointer" onClick={() => scrollTo('marco')} data-id="element-156">
        <ChevronDown size={24} data-id="element-157" />
      </motion.div>
    </section>;
}